import { tm } from '../tm'
import type { CSSProperties } from 'react'

interface HtmlProps {
  as?: 'h1' | 'h2' | 'p' | 'div'
  children: string
  className?: string
  style?: CSSProperties
}

const emptyObject = {}
export function Html({
  as = 'div',
  children,
  className = '',
  style = emptyObject,
}: HtmlProps) {
  if (!children) return null

  const Component = as

  const enhancedHtml = children.replace(
    /<a href="/gm,
    '<a target="_blank" rel="noreferrer noopener" href="',
  )

  return (
    <Component
      className={tm(
        'text-sm [&_a]:underline [&_ul]:ml-6 [&_ul]:mt-2 [&_ul]:list-disc',
        className,
      )}
      style={style}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: enhancedHtml,
      }}
    />
  )
}
